export default {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function (event) {
      // Check if the clicked element is neither the element
      // to which the directive is applied nor its child
      if (!(el === event.target || el.contains(event.target))) {
        
        // Handle teleported elements or additional exclude elements
        // binding.arg can contain a ref to additional elements to exclude
        if (binding.arg && binding.arg.value) {
          const excludeElements = Array.isArray(binding.arg.value) ? binding.arg.value : [binding.arg.value]
          
          for (const excludeEl of excludeElements) {
            if (excludeEl && (excludeEl === event.target || excludeEl.contains(event.target))) {
              return // Don't trigger the callback if clicked inside excluded element
            }
          }
        }
        
        // Check if target has data attributes that indicate it should be excluded
        const target = event.target
        if (target && target.closest('[data-click-outside-ignore]')) {
          return // Don't trigger if clicked inside ignored elements
        }
        
        // Invoke the provided method
        binding.value(event)
      }
    }
    
    el.escapeEvent = function (event) {
      // Check if the escape key was pressed
      if (event.key === 'Escape') {
        // Invoke the provided method
        binding.value(event)
      }
    }
    
    document.addEventListener('click', el.clickOutsideEvent)
    document.addEventListener('keydown', el.escapeEvent)
  },
  unmounted(el) {
    // Remove the event listeners when the bound element is unmounted
    document.removeEventListener('click', el.clickOutsideEvent)
    document.removeEventListener('keydown', el.escapeEvent)
  },
}
